// hooks/useAdmin.ts
import { useMemo } from 'react';

export interface User {
  id: number;
  username: string;
  full_name?: string;
  email?: string;
  role?: 'user' | 'admin' | 'superadmin' | 'super_admin';
  setUser?: (user: any) => void;
}

export const useAdmin = (user: User | null) => {
  const isAdmin = useMemo(() => {
    if (!user) return false;
    
    if (user.role === 'admin' || user.role === 'superadmin' || user.role === 'super_admin') {
      return true;
    }
        const adminUsernames = ['admin', 'administrator', 'superadmin'];
    return adminUsernames.includes(user.username?.toLowerCase());
  }, [user]);

  return { isAdmin };
};